import { HttpClient } from '@angular/common/http'
import { TranslateLoader } from '@ngx-translate/core'
import { catchError, map, Observable, of, switchMap } from 'rxjs'
import { environment } from '../../environments/environment'

export const supportedLocales = ['en', 'fr', 'de']
export const defaultLocale = 'de' // Fallback locale

export const getSupportedLocale = (browserLang: string): string => {
  const language = browserLang.split('-')[0] // Extract the base language (e.g., "en" from "en-US")
  const supportedLocale = supportedLocales.find(locale => locale.startsWith(language))
  return supportedLocale || defaultLocale
}

export const browserLang = navigator.language || navigator.languages[0]

export class CustomTranslateLoader implements TranslateLoader {
  constructor(private http: HttpClient) {}

  getTranslation(lang: string): Observable<any> {
    const manifestUrl = environment.useCustomTranslation
      ? `./assets/i18n/${environment.translationFolder}/manifest.json`
      : `./assets/i18n/manifest.json`
    return this.http.get<{ [key: string]: string }>(manifestUrl).pipe(
      map(manifest => {
        if (environment.useCustomTranslation) {
          const hash = manifest[`${lang}.json`]
          return `./assets/i18n/${environment.translationFolder}/${lang}.json?cb=${hash}`
        }
        const hash = manifest[`${lang}.json`]
        return `./assets/i18n/${lang}.json?cb=${hash}`
      }),
      switchMap(url => this.http.get(url)),
      catchError(() => of({})),
    )
  }
}

export function HttpLoaderFactory(http: HttpClient): CustomTranslateLoader {
  return new CustomTranslateLoader(http)
}
